<template>
  <section class="page-section">
        <el-tabs v-model="tabName" type="card" @tab-click="handleTabsChange">
          <el-tab-pane label="销售中" name="1"></el-tab-pane>
          <el-tab-pane label="已售罄" name="2"></el-tab-pane>
          <el-tab-pane label="仓库中" name="0"></el-tab-pane>
        </el-tabs>
        <!-- filter -->
        <div class="filter-region">
          <div class="filter-form">
            <el-form
              size="small"
              :inline="true"
              :model="filterForm"
              ref="filterForm"
            >
              <el-form-item label="商品名：" prop="name">
                <el-autocomplete
                  v-model="filterForm.name"
                  :fetch-suggestions="handleFilterGoodsNameSuggestions"
                  :trigger-on-focus="false"
                  placeholder="请输入"
                ></el-autocomplete>
              </el-form-item>
              <el-form-item label="商品分类：" prop="firstCategoryId">
                <el-select
                  filterable
                  v-model="filterForm.firstCategoryId"
                  placeholder="请选择"
                  @change="handleFilterFormFirstCategoryChange"
                >
                  <el-option
                    v-for="item in firstCategoryOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品类型：" prop="commodityType">
                <el-select
                  v-model="filterForm.commodityType"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in commodityTypeOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="" prop="secondCategoryId">
                <el-select
                  filterable
                  v-model="filterForm.secondCategoryId"
                  placeholder="请选择"
                  @change="secondCategoryIdEvent"
                >
                  <el-option
                    v-for="item in secondCategoryOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :label="
                  tabName == '1'
                    ? '上架时间：'
                    : tabName == '2'
                    ? '下架时间：'
                    : '最后编辑时间：'
                "
                prop="time"
                class="auto-width"
              >
                <el-date-picker
                  v-model="filterForm.time"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-form>
          </div>
          <div class="filter-btn">
            <el-button-group class="btn-group">
              <el-button
                plain
                class="btn-reset"
                icon="el-icon-refresh"
                @click="filterFormReset('filterForm')"
              ></el-button>
              <el-button
                type="primary"
                class="btn-search"
                @click="filterFormSubmit('filterForm')"
                :loading="tableLoading"
                >查询</el-button
              >
            </el-button-group>
          </div>
        </div>
        <el-button
          class="btn-add-block"
          type="primary"
          @click="pageNavigateToGoodsManageAdd"
          >发布商品</el-button
        >

        <!-- table -->
        <div class="table-region" v-loading="tableLoading">
          <el-table
            size="small"
            :data="tableData"
            ref="multipleTable"
            @selection-change="handleTableSelectionChange"
          >
            <el-table-column type="selection" width="42"></el-table-column>
            <el-table-column label="商品" width="200">
              <template slot-scope="scope">
                <div class="goods-title">
                  <div class="thumb-wrap">
                    <img :src="scope.row.mainPic" />
                  </div>
                  <!-- <p>商品编码{{ scope.row.code }}</p> -->
                  <p>{{ scope.row.name }}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="商品类型">
              <template slot-scope="scope">
                <div v-if="scope.row.commodityType == '1'">普通商品</div>
                <div v-if="scope.row.commodityType == '2'">专链商品</div>
              </template>
            </el-table-column>
            <el-table-column label="一级分类">
              <template slot-scope="scope">
                <p>{{ getCategoryLabel(scope.row.category, 1) }}</p>
              </template>
            </el-table-column>
            <el-table-column label="二级分类">
              <template slot-scope="scope">
                <p>{{ getCategoryLabel(scope.row.category, 2) }}</p>
              </template>
            </el-table-column>
            <el-table-column label="排序号">
              <template slot-scope="scope">
                <p>{{ scope.row.sort }}</p>
              </template>
            </el-table-column>
            <el-table-column label="规格">
              <template slot-scope="scope">
                <p
                  v-for="(record, recordIndex) in scope.row.commodityDetailSku
                    .specificationSkus"
                  :key="recordIndex"
                  style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >
                  {{ record.sku.join(" ") }}
                </p>
              </template>
            </el-table-column>
            <!-- <el-table-column label="类目标签">
                            <template slot-scope="scope">
                                <p v-for="(item, index) in scope.row.labels" :key="index">{{ item }}</p>
                            </template>
                        </el-table-column> -->
            <el-table-column label="价格(人民币)" sortable sort-by="price">
              <template slot-scope="scope">
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                  "
                >
                  <div>
                    <p
                      v-for="(record, recordIndex) in scope.row
                        .commodityDetailSku.specificationSkus"
                      :key="recordIndex"
                    >
                      ￥{{ getPrice(record.price, scope.row, "price") }}
                    </p>
                  </div>
                  <div>
                    <!-- 价格 -->
                    <el-popover
                      placement="top"
                      width="auto"
                      v-model="scope.row.editPriceVisible"
                      popper-class="confirm-popover"
                      @show="handleEdit(scope.row.id)"
                      v-if="!tableLoading"
                    >
                      <el-table
                        size="small"
                        :data="specification.particularData"
                        style="width: 100%"
                        class="paticular-table list-table"
                        height="275"
                        :span-method="handleParticularTableRowMethod"
                        v-loading="specificationLoading"
                      >
                        <el-table-column
                          :label="specification.list[0].name"
                          v-if="
                            specification.list[0] &&
                            specification.list[0].id &&
                            specification.list[0].valueNameList.length > 0
                          "
                        >
                          <template slot-scope="subScope">
                            <p>{{ subScope.row.firstValue }}</p>
                          </template>
                        </el-table-column>
                        <el-table-column
                          :label="specification.list[1].name"
                          v-if="
                            specification.list[1] &&
                            specification.list[1].id &&
                            specification.list[1].valueNameList.length > 0
                          "
                        >
                          <template slot-scope="subScope">
                            <p>{{ subScope.row.secondValue }}</p>
                          </template>
                        </el-table-column>
                        <el-table-column
                          :label="specification.list[2].name"
                          v-if="
                            specification.list[2] &&
                            specification.list[2].id &&
                            specification.list[2].valueNameList.length > 0
                          "
                        >
                          <template slot-scope="subScope">
                            <p>{{ subScope.row.thirdValue }}</p>
                          </template>
                        </el-table-column>
                        <el-table-column label="* 价格(元)" width="120px">
                          <template slot-scope="subScope">
                            <el-input
                              type="number"
                              v-model="subScope.row.price"
                            ></el-input>
                          </template>
                        </el-table-column>
                      </el-table>

                      <div>
                        <el-button
                          size="small"
                          type="default"
                          plain
                          @click="scope.row.editPriceVisible = false"
                          >取消</el-button
                        >
                        <el-button
                          size="small"
                          type="primary"
                          @click="handleSaveEdit(scope.row)"
                          :loading="operateLoading"
                          >确定</el-button
                        >
                      </div>

                      <el-button
                        size="small"
                        type="text"
                        icon="el-icon-edit"
                        slot="reference"
                        class="button-edit"
                      ></el-button>
                    </el-popover>
                  </div>
                </div>
                <!-- <p style="text-decoration: line-through;" v-if="scope.row.nickPrice">￥{{ scope.row.nickPrice }}</p> -->
              </template>
            </el-table-column>
            <el-table-column label="价格(韩元)" sortable sort-by="price">
              <template slot-scope="scope">
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                  "
                >
                  <div>
                    <p
                      v-for="(record, recordIndex) in scope.row
                        .commodityDetailSku.specificationSkus"
                      :key="recordIndex"
                    >
                      ₩{{
                        getPrice(record.koreaPrice, scope.row, "koreaPrice")
                      }}
                    </p>
                  </div>
                </div>
                <!-- <p>₩{{ scope.row.koreaPrice }}</p> -->
                <!-- <p style="text-decoration: line-through;" v-if="scope.row.koreaLinePrice">₩{{ scope.row.koreaLinePrice }}</p> -->
              </template>
            </el-table-column>
            <el-table-column label="库存" sortable sort-by="stock">
              <template slot-scope="scope">
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                  "
                >
                  <div>
                    <p
                      v-for="(record, recordIndex) in scope.row
                        .commodityDetailSku.specificationSkus"
                      :key="recordIndex"
                    >
                      {{ record.stock }}
                    </p>
                  </div>
                  <p>
                    <!-- {{ scope.row.stock }}&nbsp; -->
                    <!-- 库存 -->
                    <el-popover
                      placement="top"
                      width="auto"
                      v-model="scope.row.editStockVisible"
                      popper-class="confirm-popover"
                      @show="handleEdit(scope.row.id)"
                      v-if="!tableLoading"
                    >
                      <el-table
                        size="small"
                        :data="specification.particularData"
                        style="width: 100%"
                        class="paticular-table list-table"
                        height="275"
                        :span-method="handleParticularTableRowMethod"
                        v-loading="specificationLoading"
                      >
                        <el-table-column
                          :label="specification.list[0].name"
                          v-if="
                            specification.list[0] &&
                            specification.list[0].id &&
                            specification.list[0].valueNameList.length > 0
                          "
                        >
                          <template slot-scope="subScope">
                            <p>{{ subScope.row.firstValue }}</p>
                          </template>
                        </el-table-column>
                        <el-table-column
                          :label="specification.list[1].name"
                          v-if="
                            specification.list[1] &&
                            specification.list[1].id &&
                            specification.list[1].valueNameList.length > 0
                          "
                        >
                          <template slot-scope="subScope">
                            <p>{{ subScope.row.secondValue }}</p>
                          </template>
                        </el-table-column>
                        <el-table-column
                          :label="specification.list[2].name"
                          v-if="
                            specification.list[2] &&
                            specification.list[2].id &&
                            specification.list[2].valueNameList.length > 0
                          "
                        >
                          <template slot-scope="subScope">
                            <p>{{ subScope.row.thirdValue }}</p>
                          </template>
                        </el-table-column>
                        <el-table-column label="* 库存" width="80px">
                          <template slot-scope="subScope">
                            <el-input
                              type="number"
                              v-model="subScope.row.stock"
                            ></el-input>
                          </template>
                        </el-table-column>
                      </el-table>

                      <div>
                        <el-button
                          size="small"
                          type="default"
                          plain
                          @click="scope.row.editStockVisible = false"
                          >取消</el-button
                        >
                        <el-button
                          size="small"
                          type="primary"
                          @click="handleSaveEdit(scope.row)"
                          :loading="operateLoading"
                          >确定</el-button
                        >
                      </div>

                      <el-button
                        size="small"
                        type="text"
                        icon="el-icon-edit"
                        slot="reference"
                        class="button-edit"
                      ></el-button>
                    </el-popover>
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="总销量" sortable sort-by="sale">
              <template slot-scope="scope">
                <p>{{ scope.row.sale > 0 ? scope.row.sale : "-" }}</p>
              </template>
            </el-table-column>
            <!-- <el-table-column label="访问量">
                            <template slot-scope="scope">
                                <p>访客数：{{ scope.row.visitor }}</p>
                                <p>浏览数：{{ scope.row.browse }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="运费计算方式">
                            <template slot-scope="scope">
                                <p v-if="scope.row.deliverType == 1">统一运费</p>
                                <p v-if="scope.row.deliverType == 2">按件数</p>
                                <p v-if="scope.row.deliverType == 3">按重量</p>
                            </template>
                        </el-table-column> -->
            <el-table-column
              :label="
                tabName == '1'
                  ? '上架时间'
                  : tabName == '2'
                  ? '下架时间'
                  : '最后编辑时间'
              "
              width="95"
              sortable
              sort-by="createDate"
            >
              <template slot-scope="scope">
                <p v-if="tabName == '1'">
                  {{ COMMON.formatDate("2", "-", scope.row.listingTime) }}
                </p>
                <p v-if="tabName == '2'">
                  {{ COMMON.formatDate("2", "-", scope.row.listingTime) }}
                </p>
                <p v-if="tabName == '0'">
                  {{ COMMON.formatDate("2", "-", scope.row.lastUpdateDate) }}
                </p>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="right">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="text"
                  @click="pageNavigateToGoodsManageAdd(scope.row)"
                  >编辑</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="table-footer" v-if="page.total > 0">
          <div class="selection-operate">
            <el-checkbox v-model="allSelect" @change="handleAllSelectChange"
              >全选当页</el-checkbox
            >

            <div class="button-wrap">
              <!-- 上架 -->
              <el-popover
                placement="top"
                width="165"
                v-model="operate.upVisible"
                popper-class="confirm-popover"
                v-if="tabName == 0"
              >
                <p>上架后,可在"销售中"查看该商品，确定上架？</p>
                <div>
                  <el-button
                    size="small"
                    type="default"
                    plain
                    @click="handleOperateCancle"
                    >取消</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    @click="handleUpdateStatus(1)"
                    :loading="operateLoading"
                    >确定</el-button
                  >
                </div>

                <el-button size="small" type="default" plain slot="reference"
                  >上架</el-button
                >
              </el-popover>

              <!-- 下架 -->
              <el-popover
                placement="top"
                width="165"
                v-model="operate.downVisible"
                popper-class="confirm-popover"
                v-if="tabName == 1"
              >
                <p>下架后，可在"仓库中"查看该商品，确定下架？</p>
                <div>
                  <el-button
                    size="small"
                    type="default"
                    plain
                    @click="handleOperateCancle"
                    >取消</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    @click="handleUpdateStatus(0)"
                    :loading="operateLoading"
                    >确定</el-button
                  >
                </div>

                <el-button size="small" type="default" plain slot="reference"
                  >下架</el-button
                >
              </el-popover>

              <!-- 删除 -->
              <el-popover
                placement="top"
                width="165"
                v-model="operate.deleteVisible"
                popper-class="confirm-popover"
              >
                <p>确定删除该商品？</p>
                <div>
                  <el-button
                    size="small"
                    type="default"
                    plain
                    @click="handleOperateCancle"
                    >取消</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    @click="handleUpdateStatus(3)"
                    :loading="operateLoading"
                    >确定</el-button
                  >
                </div>

                <el-button size="small" type="default" plain slot="reference"
                  >删除</el-button
                >
              </el-popover>
            </div>
          </div>

          <div class="pagination-wrap">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[20, 50, 100]"
              :pager-count="5"
              :current-page="page.current"
              :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total"
            >
            </el-pagination>
          </div>
        </div>
        <!-- </div> -->
      </section>
</template>

<script>
import {
  COMMON,
  commodityList,
  commodityCategoryList,
  commodityUpdateStatus,
  commodityListSku,
  commodityListUpdateSku,
  commodityCategoryLabelList,
  validGoodsList,
  commodityFilterOptions,
} from "@/common/api";

export default {
  name: "goodsManageList",
  data() {
    return {
      COMMON,

      tabName: "1", //选项卡name

      filterForm: {
        //筛选表单值
        name: "", // 商品名
        firstCategoryId: "", // 一级商品类目
        secondCategoryId: "", // 二级商品类目
        moduleId: "", // 关键词
        deliverFeeType: "", // 运费类型
        templateId: "",
        marketingType: "",
        marketingId: "",
        time: [],
        commodityType: "",
      },
      nameSuggestionsOptions: [], // 商品名字列表
      firstCategoryOptions: [], // 一级商品类目下拉列表
      secondCategoryOptions: [], // 二级商品类目下拉列表
      moduleOptions: [], // 关键词下拉列表
      templateOptions: [],
      marketingOptions: [],

      tableLoading: true,
      tableData: [], //表格数据
      page: {
        current: 1,
        size: 20,
        total: 0,
      },

      multipleSelection: [], // 选中的数据
      allSelect: false, //全选当页
      operate: {
        upVisible: false, // 上架
        downVisible: false, // 下架
        deleteVisible: false, // 删除
      },
      operateLoading: false,

      specification: {
        list: [], // 规格列表
        particularData: [], // 规格明细列表
      },
      specificationLoading: false,
      tableHeight: 400,
      commodityTypeOptions: [
        { id: 1, name: "普通商品" },
        { id: 2, name: "专链商品" },
      ],
    };
  },
  computed: {
    getCategoryLabel(category, type) {
      return function (category, type) {
        let label = "";
        if (category && category[0]) {
          let arr = category[0].split(",");
          if (type == 1) {
            return arr[0];
          } else if (type == 2) {
            return arr[1];
          }
        }

        return label;
      };
    },
    getPrice(price, row, field) {
      return function (price, row, field) {
        const { unit, rate } = row;
        if (unit == 1) {
          // 韩元
          if (field == "price") {
            return (price * rate).toFixed(2);
          } else if (field == "koreaPrice") {
            return price;
          }
        } else {
          // 人民币
          if (field == "price") {
            return price;
          } else if (field == "koreaPrice") {
            return Math.ceil(price / rate);
          }
        }
      };
    },
  },
  methods: {
    /**
     * [handleFilterGoodsNameSuggestions description] 商品名字联想
     * @param  {[type]}   query [description]
     * @param  {Function} cb    [description]
     * @return {[type]}         [description]
     */
    handleFilterGoodsNameSuggestions: function (query, cb) {
      let list = this.nameSuggestionsOptions;
      let results = query ? list.filter(this.createFilter(query)) : list;

      cb(results);
    },
    createFilter(query) {
      return (item) => {
        return item.value.toLowerCase().indexOf(query.toLowerCase()) === 0;
      };
    },
    /**
     * [handleTabsChange description] 切换选项卡
     * @param  {[type]} tab   [description] 取name值用tab.name
     * @param  {[type]} event [description]
     * @return {[type]}       [description]
     */
    handleTabsChange: function (tab, event) {
      // 初始化状态
      this.filterForm = {
        name: "",
        firstCategoryId: "",
        secondCategoryId: "",
        moduleId: "",
        deliverFeeType: "",
        templateId: "",
        marketingType: "",
        marketingId: "",
      };
      this.secondCategoryOptions = [];

      this.page.current = 1;
      this.multipleSelection = [];
      this.allSelect = false;
      this.handleOperateCancle();

      this.getList();
    },
    /**
     * [getList description] 获取表格数据
     * @return {[type]} [description]
     */
    getList: function () {
      this.tableLoading = true;

      let time = this.filterForm.time;
      let params = {
        status: parseFloat(this.tabName),
        name: this.filterForm.name,
        secondCategoryId: this.filterForm.secondCategoryId || null,
        moduleId: this.filterForm.moduleId || null,
        deliverFeeType: this.filterForm.deliverFeeType || null,
        templateId: this.filterForm.templateId || null,
        marketingType: this.filterForm.marketingType || null,
        marketingId: this.filterForm.marketingId || null,
        commodityType: this.filterForm.commodityType || null,
        startTime: time && time.length > 1 ? new Date(time[0]).getTime() : null,
        endTime:
          time && time.length > 1
            ? new Date(time[1]).getTime() + 24 * 60 * 60 * 1000 - 1
            : null,
        isJoinGoods: "0",
        current: this.page.current,
        size: this.page.size,
      };

      commodityList(params)
        .then((res) => {
          this.tableLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            let dataArray = data.records || [];
            if (dataArray && dataArray.length > 0) {
              dataArray.map((row) => {});
            }
            this.tableData = dataArray;
            this.page.total = data.total;
            this.$nextTick(() => {
              const scrollContainer = document.querySelector(".app-container");
              if (scrollContainer) {
                scrollContainer.scrollTop = 0;
              }
            });
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.$message.error("服务器异常");
        });
    },

    /**
     * [getGoodsNameList description] 获取商品名字列表
     * @return {[type]} [description]
     */
    getGoodsNameList: function () {
      validGoodsList({}).then((res) => {
        if (res.code == 0) {
          let data = res.data || [],
            arr = [];

          data.map((item) => {
            arr.push({
              value: item,
            });
          });

          this.nameSuggestionsOptions = arr;
        }
      });
    },
    /**
     * [getCategoryLabelList description] 获取类目标签下拉列表
     * @return {[type]} [description]
     */
    getCategoryLabelList: function (secondCategoryId) {
      let params = {
        secondCategoryId: secondCategoryId,
      };

      commodityCategoryLabelList(params).then((res) => {
        if (res.code == 0) {
          if (res.data) {
            this.moduleOptions = res.data;
          }
        }
      });
    },
    /**
     * [secondCategoryIdEvent description] 二级类目变化监听
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    secondCategoryIdEvent() {
      this.getCategoryLabelList(this.filterForm.secondCategoryId);
    },
    /**
     * [templateIdEvent description] 运费二级下拉列表
     * @return {[type]} [description]
     */
    templateIdEvent() {
      let type = "";

      if (this.filterForm.deliverFeeType == "1") {
        // 统一运费
        type = 7;
      } else if (this.filterForm.deliverFeeType == "2") {
        // 按件计费
        type = 8;
      } else if (this.filterForm.deliverFeeType == "3") {
        // 按重量计费
        type = 9;
      }

      let params = {
        type: type,
      };

      commodityFilterOptions(params).then((res) => {
        let { code, data, successInfo, msg } = res;

        if (code == 0) {
          let dataArray = data || [];

          dataArray.map((item) => {
            item.relateId = "" + item.relateId;
          });

          this.templateOptions = dataArray;
        }
      });
    },
    /**
     * [marketingIdEvent description] 营销二级下拉列表
     * @return {[type]} [description]
     */
    marketingIdEvent() {
      let type = "";

      if (this.filterForm.marketingType == "0") {
        // 满N元就送
        type = 6;
      } else if (this.filterForm.marketingType == "1") {
        // 现金券
        type = 4;
      } else if (this.filterForm.marketingType == "2") {
        // 满减券
        type = 5;
      }

      let params = {
        type: type,
      };

      commodityFilterOptions(params).then((res) => {
        let { code, data, successInfo, msg } = res;

        if (code == 0) {
          let dataArray = data || [];

          dataArray.map((item) => {
            item.relateId = "" + item.relateId;
          });

          this.marketingOptions = dataArray;
        }
      });
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.current = 1;
      this.page.size = val;
      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择分页第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
    /**
     * [getFirstCategoryList description] 获取一级商品下拉列表
     * @return {[type]} [description]
     */
    getFirstCategoryList: function () {
      let params = {
        type: 1,
      };

      commodityCategoryList(params).then((res) => {
        let { code, data, successInfo, msg } = res;

        if (code == 0) {
          let dataArray = data || [];

          this.firstCategoryOptions = dataArray;
        }
      });
    },
    /**
     * [handleFilterFormFirstCategoryChange description] 监听表单筛选一级商品类型变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleFilterFormFirstCategoryChange: function (val) {
      this.filterForm.secondCategoryId = "";
      this.filterForm.moduleId = "";
      this.getSecondCategoryList();
    },
    /**
     * [getSecondCategoryList description] 根据一级商品类目获取二级类目下拉列表
     * @return {[type]} [description]
     */
    getSecondCategoryList: function () {
      let params = {
        type: 1,
        firstCategoryId: this.filterForm.firstCategoryId,
      };

      commodityCategoryList(params).then((res) => {
        let { code, data, msg } = res;

        if (code == 0) {
          let dataArray = data || [];

          this.secondCategoryOptions = dataArray;
        }
      });
    },
    /**
     * [filterFormSubmit description] 提交筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormSubmit: function (formName) {
      this.page.current = 1;

      this.getList();
    },
    /**
     * [filterFormReset description] 重置筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormReset: function (formName) {
      this.$refs[formName].resetFields();
      this.secondCategoryOptions = [];
    },
    /**
     * [handleTableSelectionChange description] table筛选选中状态变化
     * @param  {[type]} val [description] 选中行的数据集合array
     * @return {[type]}     [description]
     */
    handleTableSelectionChange: function (val) {
      if (val.length < this.tableData.length) {
        // 未全选中，改变底部全选状态
        this.allSelect = false;
      } else {
        this.allSelect = true;
      }

      this.multipleSelection = val;
    },
    /**
     * [handleAllSelectChange description] 全选
     * @param  {[type]} selected [description]
     * @return {[type]}          [description]
     */
    handleAllSelectChange: function (selected) {
      this.$refs.multipleTable.toggleAllSelection();
    },
    /**
     * [handleOperateCancle description] 操作popover - 取消
     * @return {[type]} [description]
     */
    handleOperateCancle: function () {
      this.operate = {
        upVisible: false,
        downVisible: false,
        deleteVisible: false,
      };
    },
    /**
     * [handleUpdateStatus description] 商品上下架、删除
     * @param  {[type]} status [description]
     * @return {[type]}        [description]
     */
    handleUpdateStatus: function (status) {
      let statusName = "";
      if (status == 1) {
        statusName = "上架";
      } else if (status == 0) {
        statusName = "下架";
      } else if (status == 3) {
        statusName = "删除";
      }

      if (this.multipleSelection.length == 0) {
        this.$message.error("请选择需要" + statusName + "的商品");
        this.handleOperateCancle();
        return false;
      }

      this.operateLoading = true;

      let ids = [];
      for (let i = 0; i < this.multipleSelection.length; i++) {
        ids.push(this.multipleSelection[i].id);
      }

      let params = {
        ids: ids.join(","),
        status: status,
      };

      commodityUpdateStatus(params)
        .then((res) => {
          this.operateLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            this.$message({ message: statusName + "成功", type: "success" });
            this.multipleSelection = [];
            this.handleOperateCancle();
            this.getList();
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.operateLoading = false;
          this.$message.error("服务器异常");
        });
    },
    /**
     * [pageNavigateToGoodsManageAdd description] 跳转到发布商品页面
     * @return {[type]} [description]
     */
    pageNavigateToGoodsManageAdd: function (row) {
      if (row) {
        this.$router.push({ path: "/goods/manage/add", query: { id: row.id } });
      } else {
        this.$router.push({ path: "/goods/manage/add" });
      }
    },

    // 编辑价格或库存
    handleEdit: function (id) {
      this.specification = {
        list: [],
        particularData: [],
      };
      this.getSpecificationList(id);
    },

    // 获取规格和规格明细
    getSpecificationList: function (id) {
      this.specificationLoading = true;

      let params = {
        id: id,
      };

      commodityListSku(params)
        .then((res) => {
          this.specificationLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            this.specification = {
              list: data.specificationList || [],
              particularData: data.specificationDetailList || [],
            };
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.$message.error("服务器异常");
        });
    },

    //  保存编辑
    handleSaveEdit: function (record) {
      this.operateLoading = true;

      let particularData = JSON.parse(
        JSON.stringify(this.specification.particularData),
      );
      particularData.map((row) => {
        row.commodityId = record.id;
        row.stock = parseFloat(row.stock);
      });

      let params = {
        skuJson: JSON.stringify(particularData),
      };

      commodityListUpdateSku(params)
        .then((res) => {
          this.operateLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            this.$message({ message: "保存成功", type: "success" });
            this.getList();
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.operateLoading = false;
          this.$message.error("服务器异常");
        });
    },

    /**
     * [handleParticularTableRowMethod description] 合并规格明细表格中相同的规格名
     * @param  {[type]} options.row         [description]
     * @param  {[type]} options.column      [description]
     * @param  {[type]} options.rowIndex    [description]
     * @param  {[type]} options.columnIndex [description]
     * @return {[type]}                     [description]
     */
    handleParticularTableRowMethod: function ({
      row,
      column,
      rowIndex,
      columnIndex,
    }) {
      let specificationList = this.specification.list,
        particularData = [],
        firstLen = this.handleGetSpecificationValuesLenthMethod(0) || 1,
        secondLen = this.handleGetSpecificationValuesLenthMethod(1) || 1,
        thirdLen = this.handleGetSpecificationValuesLenthMethod(2) || 1;

      if (
        specificationList[0] &&
        specificationList[0].valueNameList.length > 0 &&
        columnIndex === 0
      ) {
        if (rowIndex % (secondLen * thirdLen) === 0) {
          return {
            rowspan: secondLen * thirdLen,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }

      if (
        specificationList[1] &&
        specificationList[1].valueNameList.length > 0 &&
        columnIndex === 1
      ) {
        if (rowIndex % thirdLen === 0) {
          return {
            rowspan: thirdLen,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    /**
     * [handleGetSpecificationValuesLenthMethod description] 获取各个规格名下规格值不为空的规格值长度
     * @param  {[type]} index [description] 规格名的索引
     * @return {[type]}       [description]
     */
    handleGetSpecificationValuesLenthMethod: function (index) {
      let specificationList = this.specification.list,
        item = specificationList[index],
        len = 0;

      if (item && item.valueNameList.length > 0) {
        for (let i = 0; i < item.valueNameList.length; i++) {
          if (item.valueNameList[i].name) {
            len += 1;
          }
        }
      }

      return len;
    },
    /**
     * [calcTableHeight description] 动态计算表格高度
     * @return {[type]} [description]
     */
    calcTableHeight() {
      // 废除表格强制高计算
      // const tableRegion = document.querySelector('.table-region')
      // const tableFooter = document.querySelector('.table-footer')
      // if (tableRegion) {
      //   const regionHeight = tableRegion.clientHeight
      //   const footerHeight = tableFooter ? tableFooter.offsetHeight : 0
      //   this.tableHeight = regionHeight - footerHeight - 20 // 20px 为边距
      //   this.$nextTick(() => {
      //     this.$refs.multipleTable && this.$refs.multipleTable.doLayout()
      //   })
      // }
    },
  },
  mounted() {
    this.getList();
    this.getGoodsNameList();
    this.getFirstCategoryList();
    // this.$nextTick(() => {
    //   this.calcTableHeight()
    // })
    // window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy() {
    // window.removeEventListener('resize', this.calcTableHeight)
  },
};
</script>

<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";
@import "../../../common/styles/base/mixin-common";

.goods-title {
  position: relative;
  padding-left: 58px;
  min-height: 48px;

  .thumb-wrap {
    @include position(absolute, 3, 50%, none, none, 0);
    width: 48px;
    height: 48px;
    margin-top: -24px;
    background-color: $colorPageBg;

    img {
      max-width: 100%;
      max-height: 100%;
      @include position(absolute, 1, 50%, none, none, 50%);
      @include translate(-50%, -50%, 0);
    }
  }

  p {
    line-height: 1.4;

    & + p {
      margin-top: 5px;
    }
  }
}

.button-edit {
  display: none;
}

.el-table__row {
  &:hover {
    .button-edit {
      display: inline-block;
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}

.paticular-table {
  margin-top: 0;
  background-color: transparent;

  &::before {
    display: none;
  }

  .el-table__header-wrapper {
  }

  ::v-deep .el-table__body-wrapper {
    .el-table__body {
      .el-table__row {
        background-color: transparent;

        td {
          padding: 5px 0;
          border-bottom-color: #ebeef5;
          /*border-bottom-color: transparent;*/
        }
      }
    }
  }
}

// .page-container {
//   height: 100%;
// }

// .page-main {
//   flex: 1;
//   overflow: hidden;
//   display: flex;
//   flex-direction: column;
// }

// .page-section {
//   display: flex;
//   flex-direction: column;
//   flex: 1;
//   overflow: hidden;

//   .btn-add-block {
//     flex-shrink: 0;
//     align-self: flex-start;
//   }
// }

.filter-region {
  // flex-shrink: 0; // 筛选区域不压缩
  display: flex;
  align-items: center;
  justify-content: space-between;

  .filter-btn {
    height: 100%;

    .btn-group {
      display: flex;

      .btn-reset {
        width: 40px;
        height: 40px;
        border-color: #3388ff;
        color: #3388ff;
      }

      .btn-search {
        width: 84px;
        height: 40px;
      }

      .el-button {
        & + .el-button {
          margin-left: -1px !important;
        }

        &:first-child {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        &:last-child {
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
        }
      }
    }
  }

  ::v-deep .btn-add-serve {
    .el-form-item__content {
      width: 70px;
    }
  }
}

.table-region {
  // flex: 1; // 占用剩余高度
  // display: flex;
  // flex-direction: column;
  // overflow: hidden;
  margin-bottom: 50px;

  ::v-deep .el-table {
    // flex: 1;

    &::before {
      height: 0;
    }
  }

  // 修复固定列头部背景色不一致问题
  ::v-deep .el-table__fixed-right-patch {
    background-color: #f6f7f9; // $colorTitleBg 的值，或者直接写变量如果可用
    border-bottom: none;
  }

  ::v-deep .el-table__fixed-right {
    thead th {
      background-color: #f6f7f9;
      border-bottom: none;
    }

    &::before {
      height: 0;
    }
  }

  // .table-footer {
  //   flex-shrink: 0; // 分页区域不压缩，保持固定高度
  // }
}
</style>
